import PropTypes from 'prop-types';
import React from 'react';
import StyledLink from './styled-link';

const sizes = ['large', 'medium', 'small'];

const propTypes = {
	children: PropTypes.node,
	dataTestId: PropTypes.string,
	disabled: PropTypes.bool,
	icon: PropTypes.element,
	iconRight: PropTypes.bool,
	size: PropTypes.oneOfType([
		PropTypes.oneOf(sizes),
		PropTypes.shape(
			['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].reduce(
				(acc, current) => ({ ...acc, [current]: PropTypes.oneOf(sizes) }),
				{},
			),
		),
	]),
	underline: PropTypes.bool,
	white: PropTypes.bool,
};
const defaultProps = {
	children: null,
	dataTestId: null,
	disabled: undefined,
	icon: undefined,
	iconRight: false,
	size: 'large',
	underline: true,
	white: false,
};

export function SpanLink({ dataTestId, disabled, ...props }) {
	return (
		<StyledLink
			aria-disabled={disabled ? true : undefined}
			className="fuse-span-link"
			data-testid={dataTestId}
			{...props}
			as="span"
		/>
	);
}

SpanLink.propTypes = propTypes;
SpanLink.defaultProps = defaultProps;
SpanLink.displayName = 'SpanLink';

export default SpanLink;
